/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * What a gamification model can feed into on milestone/completion
 * @export
 */
export const GamificationOutputTargetType = {
    LEADERBOARD: 'LEADERBOARD',
    RAFFLE: 'RAFFLE',
    GAMIFICATION_MODEL: 'GAMIFICATION_MODEL',
    BRAND_CHALLENGE: 'BRAND_CHALLENGE'
} as const;
export type GamificationOutputTargetType = typeof GamificationOutputTargetType[keyof typeof GamificationOutputTargetType];


export function instanceOfGamificationOutputTargetType(value: any): boolean {
    for (const key in GamificationOutputTargetType) {
        if (Object.prototype.hasOwnProperty.call(GamificationOutputTargetType, key)) {
            if (GamificationOutputTargetType[key as keyof typeof GamificationOutputTargetType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GamificationOutputTargetTypeFromJSON(json: any): GamificationOutputTargetType {
    return GamificationOutputTargetTypeFromJSONTyped(json, false);
}

export function GamificationOutputTargetTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GamificationOutputTargetType {
    return json as GamificationOutputTargetType;
}

export function GamificationOutputTargetTypeToJSON(value?: GamificationOutputTargetType | null): any {
    return value as any;
}

export function GamificationOutputTargetTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): GamificationOutputTargetType {
    return value as GamificationOutputTargetType;
}

